/**
 * @author Martin Albarracin
 * @file routes.js
 * @description Video calls routes
 */

// Pages
import VideoCallsView from '@nephro/pages/VideoCalls/videoCallsView';

const pathStart = '/main/videocall';
const routes = [
  {
    path: `${pathStart}/:meetingId/:key/:secret`,
    isProtected: true,
    component: VideoCallsView,
    exact: true
  },
  { redirect: true, to: `/main/scheduled-appointments?redirect=allow` }
];

export default routes;
